/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Geography_Delivered_AtInputs */

const vi_report_geography_delivered_at = /** @type {(inputs: Report_Geography_Delivered_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày giao`)
};

/**

* @param {Report_Geography_Delivered_AtInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_geography_delivered_at = /** @type {((inputs?: Report_Geography_Delivered_AtInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Geography_Delivered_AtInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_geography_delivered_at(inputs)
});